/** Indian grouping (e.g. 1,00,000); omits decimals when fractional part is zero. */
export function formatIndianAmount(value) {
  const num = Number(value);
  if (!Number.isFinite(num)) return "0";

  return num.toLocaleString("en-IN", {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}

export function formatIndianRupee(value) {
  return `₹${formatIndianAmount(value)}`;
}

/** e.g. 20/05/2026 | 06:24 PM */
export function formatFooterDateTime(date) {
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return "";

  const datePart = d.toLocaleDateString("en-GB");
  const timePart = d
    .toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    })
    .replace(/\b(am|pm)\b/gi, (match) => match.toUpperCase());

  return `${datePart} | ${timePart}`;
}
